import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ crumbs }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-8">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs font-semibold text-violet-200">
      {crumbs.map(([name, path], i) => (
        <li key={path} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3 w-3" aria-hidden />}
          {i < crumbs.length - 1 ? (
            <Link to={path} className="transition-colors hover:text-white">{name}</Link>
          ) : (
            <span aria-current="page" className="text-white">{name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
